import { useLocalSearchParams } from 'expo-router';

import { SpendReview } from '../../../onboarding/components/SpendReview';

export default function SpendScreen() {
    const { context } = useLocalSearchParams<{
        context?: 'profile' | 'onboarding' | 'before-money-map-session';
    }>();

    return <SpendReview context={context ?? 'profile'} />;
}
